import i18next from "../i18n/config";

export const getWhyWeReasons = () => ({
  cards: [
    {
      title: i18next.t("whyWe.title1"),
      description: i18next.t("whyWe.description1"),
    },
    {
      title: i18next.t("whyWe.title2"),
      description: i18next.t("whyWe.description2"),
    },
    {
      title: i18next.t("whyWe.title3"),
      description: i18next.t("whyWe.description3"),
    },
  ],
});
